<script setup>
import {computed} from 'vue'

import PageEditorContentNavContentItem from "./PageEditorContentNavContentItem.vue"
import {usePageContentDataStore} from '@/stores/pageContentData'
import {usePageEditorStore} from '@/stores/pageEditor'

const props = defineProps({
    contentAreaName: String
})

const pageContentDataStore = usePageContentDataStore()
const pageEditorStore = usePageEditorStore()

const pageId = computed(() => pageEditorStore.pageId)

const pageContentIds = computed(() => {
    if (props.contentAreaName === 'Page header' || props.contentAreaName === 'Page footer') {
        return pageEditorStore.contentItems
            .filter(o => o.contentAreaName === props.contentAreaName)
            .map(o => o.pageContentId)
    } else {
        return (pageContentDataStore.items || [])
            .filter(o => o.pageId === pageId.value && o.contentArea === props.contentAreaName)
            .sort((a, b) => (a.displayOrder > b.displayOrder) ? 1 : -1)
            .map(o => o.id)
    }
})
</script>

<template>
    <div>
        <PageEditorContentNavContentItem v-for="pageContentId in pageContentIds" :key="pageContentId"
                                         :page-content-id="pageContentId"/>
    </div>
</template>